import PropTypes from "prop-types"
import React, { useState } from "react"

import Button from "src/components/Button"

import ScheduleWorkOrderModal from "./ScheduleWorkOrderModal"

const ScheduleTrigger = ({ workOrder, workOrderSequentialId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const label = workOrder.scheduledAt ? "Reschedule" : "Schedule"

  return (
    <>
      <Button
        variant="secondary"
        icon="fa-calendar-days"
        iconStyle="solid"
        onClick={() => setIsModalOpen(true)}
      >
        {label}
      </Button>
      {isModalOpen && (
        <ScheduleWorkOrderModal
          isOpen
          onClose={() => setIsModalOpen(false)}
          workOrder={workOrder}
          workOrderSequentialId={workOrderSequentialId}
        />
      )}
    </>
  )
}

ScheduleTrigger.propTypes = {
  workOrder: PropTypes.shape({
    scheduledAt: PropTypes.string,
    scheduledTime: PropTypes.string,
  }).isRequired,
  workOrderSequentialId: PropTypes.string.isRequired,
}

export default ScheduleTrigger
